import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Calculator, TrendingUp, Wallet } from 'lucide-react';
import EarningsTab from '../components/accounts/EarningsTab';
import ExpensesTab from '../components/accounts/ExpensesTab';

type TabKey = 'earnings' | 'expenses';

const tabs: { key: TabKey; label: string; icon: React.FC<{ className?: string }> }[] = [
  { key: 'earnings', label: 'Earnings', icon: TrendingUp },
  { key: 'expenses', label: 'Expenses', icon: Wallet },
];

const Accounts: React.FC = () => {
  const [active, setActive] = useState<TabKey>('earnings');

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-3">
        <div className="p-3 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-2xl shadow-lg">
          <Calculator className="h-7 w-7 text-white" />
        </div>
        <div>
          <h1 className="text-3xl font-bold text-slate-900">Accounts</h1>
          <p className="text-slate-600">Earnings & expenses overview</p>
        </div>
      </div>

      {/* Slide tab bar */}
      <div className="inline-flex p-1.5 bg-slate-100 rounded-2xl border border-slate-200">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = active === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActive(tab.key)}
              className={`relative flex items-center px-6 py-2.5 text-sm font-semibold rounded-xl transition-colors ${
                isActive ? 'text-white' : 'text-slate-600 hover:text-slate-900'
              }`}
            >
              {isActive && (
                <motion.div
                  layoutId="accounts-tab-pill"
                  className="absolute inset-0 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl shadow-lg shadow-indigo-500/30"
                  transition={{ type: 'spring', duration: 0.5 }}
                />
              )}
              <Icon className="relative z-10 mr-2 h-4 w-4" />
              <span className="relative z-10">{tab.label}</span>
            </button>
          );
        })}
      </div>

      {active === 'earnings' ? <EarningsTab /> : <ExpensesTab />}
    </div>
  );
};

export default Accounts;
